
export type StreamNotificationsParams = {
recipientId: string;
lastEventId?: number;
};
